import { Tag } from './Tag';

export const NewTag = () => <Tag variant="new">New</Tag>;
export const StartDateTag = () => <Tag variant="startDate">Start</Tag>;
export const ExpiredTag = () => <Tag variant="expired">Expired</Tag>;
export const DeadlineTag = () => <Tag variant="deadline">Deadline</Tag>;
